<ngx-spinner [fullScreen]="true">
    <p style="font-size: 20px; color: white">Veuillez patienter...</p>
</ngx-spinner>

<div class="sign-in-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()"
                [class.rtl-enabled]="themeService.isRTLEnabled()"
            >
                <div class="title text-center">
                    <h3>Connexion</h3>
                </div>
                <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Nom d'utilisateur
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Entrer le nom d'utilisateur
                            </mat-label>
                            <input matInput type="text" id="email" formControlName="username">
                        </mat-form-field>
                        <div class="error text-danger"
                             *ngIf="authForm.get('username')!.hasError('required') && authForm.get('username')!.touched">
                             Nom d'utilisateur requis.
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Mot de passe
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Entrer votre mot de passe
                            </mat-label>
                            <input matInput [type]="passHide ? 'password' : 'text'" id="password"
                                   formControlName="password">
                            <button mat-icon-button matSuffix (click)="passHide = !passHide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passHide">
                                <span class="material-symbols-outlined">
                                    {{passHide ? 'visibility_off' : 'visibility'}}
                                </span>
                            </button>
                        </mat-form-field>
                        <div class="error text-danger"
                             *ngIf="authForm.get('password')!.hasError('required') && authForm.get('password')!.touched">
                            Mot de passe requis.
                        </div>
                        <div class="error text-danger"
                             *ngIf="authForm.get('password')!.hasError('minlength') && authForm.get('password')!.touched">
                            Le mot de passe doit contenir au moins 8 caractères. 
                        </div>
                    </div>
                    <div class="info d-flex justify-content-between align-items-center">
                        <mat-checkbox formControlName="rememberMe">
                            Se souvenir de moi
                        </mat-checkbox>
                        <a routerLink="/authentication/forgot-password" class="d-inline-block text-daxa">
                            Mot de passe oublié
                        </a>
                    </div>
                    <button mat-button class="btn" type="submit">
                        Connexion
                    </button>

                </form>
            </div>
        </div>
    </div>
</div>
